import type { ExportResponse } from './exportWorker';

export type ExportHandle = {
  cancel: () => void;
  promise: Promise<Blob>;
};

export function startPdfExport(
  projectId: string,
  options: { dpi?: number; includeBleed?: boolean },
  onProgress: (current: number, total: number) => void,
): ExportHandle {
  const worker = new Worker(new URL('./exportWorker.ts', import.meta.url), { type: 'module' });

  const promise = new Promise<Blob>((resolve, reject) => {
    worker.onmessage = (event: MessageEvent<ExportResponse>) => {
      const msg = event.data;
      if (msg.type === 'progress') {
        onProgress(msg.current, msg.total);
      } else if (msg.type === 'done') {
        resolve(new Blob([msg.pdfBytes], { type: 'application/pdf' }));
        worker.terminate();
      } else if (msg.type === 'error') {
        reject(new Error(msg.message));
        worker.terminate();
      } else if (msg.type === 'cancelled') {
        reject(new DOMException('Export geannuleerd', 'AbortError'));
        worker.terminate();
      }
    };
    worker.onerror = (err) => {
      reject(new Error(err.message || 'Onbekende exportfout.'));
      worker.terminate();
    };
    worker.postMessage({
      type: 'start',
      projectId,
      dpi: options.dpi,
      includeBleed: options.includeBleed,
    });
  });

  return {
    cancel: () => worker.postMessage({ type: 'cancel' }),
    promise,
  };
}
